import React from "react";

const Select = ({
  name,
  label,
  options,
  error,
  optValue,
  optName,
  req,
  icon,
  ...rest
}) => {
  return (
    <div className={`form-group ${req && "required"}`}>
      {label && (
        <label className="form-control-label" htmlFor={name}>
          {icon && <i className={`fa ${icon}`} style={{ marginRight: '6px' }} />}
          {label}
        </label>
      )}
      <div className={icon ? "wf-input-wrap" : ""}>
        {icon && <i className={`fa ${icon} wf-input-icon`} aria-hidden="true" />}
        <select
          className={`form-control ${icon ? "wf-input-withicon" : ""}`}
          id={name}
          name={name}
          {...rest}
        >
          <option value="">Select</option>
          {options &&
            options.map((option) => (
              <option key={option[optValue]} value={option[optValue]}>
                {option[optName]}
              </option>
            ))}
        </select>
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Select;
